// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DoubleLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/DoubleLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleLeftOutlinedSvg
  }));
};

DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
export default React.forwardRef(DoubleLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DoubleLeftOutlined.js
// module id = 967
// module chunks = 0